import { render, staticRenderFns } from "./LoginHis.vue?vue&type=template&id=1228fa4b&scoped=true&"
import script from "./LoginHis.vue?vue&type=script&lang=js&"
export * from "./LoginHis.vue?vue&type=script&lang=js&"
import style0 from "./LoginHis.vue?vue&type=style&index=0&id=1228fa4b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1228fa4b",
  null
  
)

export default component.exports